import CustomizeDatePicker from "components/DatePicker";

import { Box, Typography, Grid, TextField } from "@mui/material";
import { GradientButton } from "components/GradientButton";
import { GradientButtonOutline } from "components/GradientButton";
import { Search, Visibility } from "@mui/icons-material";
import { useEffect, useState } from "react";
import useApi from "_api/index";
import TableData from "components/Car/Table";
import { formatCurrency2Digit, formatDateTime } from "utils/helpers/format";
import Actions from "components/Car/Actions";
import ModalDetailCar from "components/Modal/Car/ModalDetailCar";
import CustomPagination from "components/TableExplanded/Pagination";
const RedeemCars = () => {
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({
    search: "",
    searchDate: "",
  });
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 1,
  });
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    fetchData();
  }, [pagination.page, pagination.limit]);

  const fetchData = async (isClear = false) => {
    setLoading(true);
    try {
      const respone = await useApi.pawn_car.getListRedeemCars({
        page: isClear ? 1 : pagination.page,
        limit: pagination.limit,
        ...(!isClear && filter),
      });
      if (respone.success) {
        const { data, meta } = respone;
        let formattedData = data.map((item) => ({
          ...item.car,
          ...item.customer,
          ...item,
        }));
        setDataList(formattedData ?? []);
        setPagination({
          page: meta.page || 1,
          limit: meta.limit || 10,
          total: meta.total || 0,
          totalPages: meta.totalPages || 1,
        });
      }
    } catch (error) {
      console.error("Error fetching redeem cars:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h4">รายการไถ่ถอน</Typography>
      </Box>
      {/* search */}
      <Grid
        container
        spacing={2}
        alignContent="flex-end"
        justifyContent="flex-end"
      >
        <Grid item xs={12} sm={6} md={3}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={3}>
              <Typography
                sx={{
                  fontSize: "16px",
                  whiteSpace: "nowrap",
                }}
              >
                ค้นหาทั้งหมด
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="ค้นหาทั้งหมด"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "white",
                    height: "40px",
                  },
                }}
                value={filter.search}
                onChange={(e) =>
                  setFilter((prev) => ({
                    ...prev,
                    search: e.target.value,
                  }))
                }
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={3} textAlign={"right"}>
              <Typography
                sx={{
                  fontSize: "16px",
                  whiteSpace: "nowrap",
                }}
              >
                วันที่
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <CustomizeDatePicker
                value={filter.searchDate}
                onChange={(newValue) =>
                  setFilter((prev) => ({
                    ...prev,
                    searchDate: newValue,
                  }))
                }
                placeholder="เลือกวันที่"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Box
            sx={{
              display: "flex",
              direction: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <GradientButtonOutline
              sx={{
                px: 3,
                display: "flex",
                alignItems: "center",
                height: "40px",
              }}
              onClick={() => {
                setFilter({
                  search: "",
                  searchDate: "",
                });
                fetchData(true);
              }}
            >
              ล้าง
            </GradientButtonOutline>
            <GradientButton
              sx={{
                px: 3,
                display: "flex",
                alignItems: "center",
                height: "40px",
              }}
              endIcon={<Search />}
              onClick={() => {
                if (pagination.page === 1) {
                  fetchData();
                } else {
                  setPagination((prev) => ({ ...prev, page: 1 }));
                }
              }}
            >
              ค้นหา
            </GradientButton>
          </Box>
        </Grid>
      </Grid>

      <TableData
        data={dataList}
        loading={loading}
        columns={[
          { key: "expand", label: "" },
          {
            key: "car_pictures",
            label: "รูปภาพ",
          },
          { key: "order_code", label: "รหัสรายการ" },
          { key: "customer_idcard", label: "เลขบัตรประชาชน" },
          { key: "customer_name", label: "ชื่อ-นามสกุลผู้ฝาก" },
          {
            key: "pawn_price",
            label: "ยอดขายฝาก",
            render: (row) => {
              return formatCurrency2Digit(row?.pawn_price ?? 0);
            },
          },
          {
            key: "pawn_date",
            label: "วันที่ขายฝาก",
            render: (row) => {
              return formatDateTime(row?.pawn_date);
            },
          },
          {
            key: "updated_date",
            label: "วันที่ไถ่ถอน",
            render: (row) => {
              return formatDateTime(row?.updated_date);
            },
          },
          {
            key: "action",
            label: "Actions",
            render: (row) => {
              return (
                <Actions
                  menuList={[
                    {
                      label: "ดูรายละเอียด",
                      icon: <Visibility />,
                      onClick: () => {
                        setIsOpenModal(true);
                        setSelectedRow(row);
                      },
                    },
                  ]}
                />
              );
            },
          },
        ]}
      />
      <CustomPagination
        totalPage={pagination.totalPages}
        page={pagination.page - 1}
        onPageChange={(event, value) => {
          setPagination((prev) => ({
            ...prev,
            page: value + 1,
          }));
        }}
        rowsPerPage={pagination.limit}
        onRowsPerPageChange={(event) => {
          setPagination((prev) => ({
            ...prev,
            limit: event.target.value,
            page: 1, // Reset to first page when changing rows per page
          }));
        }}
      />
      <ModalDetailCar
        open={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        rowID={selectedRow ? selectedRow?.car_id : null}
        type="redeem_car"
        formlist={[
          {
            id: 1,
            document: "สัญญาจำนำ",
            document_type: "car_pawn_contact",
          },
          {
            id: 2,
            document: "หนังสือมอบอำนาจ",
            document_type: "car_power_of_attorney",
          },
          {
            id: 3,
            document: "แบบคำขอโอนและรับโอน",
            document_type: "car_transform",
          },
        ]}
      />
    </Box>
  );
};

export default RedeemCars;
